import React from 'react';
import { Modal, Button, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';

import { list_Internship, list_News } from '../../../helpers/actions/api.functions';
import RichTextEditor from '../../../components/RichTextEditor';
import toast from 'react-hot-toast';

const AddInternship = ({ open, handleClose, handleApply, ...props }) => {
    const file1Ref = useRef(null);
    const [data, setData] = useState([]);
    const [formData, setformData] = useState({ ...props.data, organisation: 'KIED' });
    const [imageOneChanged, setImageOneChanged] = useState(false);
    const handleChange = (name, value) => {
        let sanitizedValue = value;
        const omitSanitization = ['designation', 'photo'];

        if (!omitSanitization.includes(name)) {
            sanitizedValue = value.replace(/<\/?[^>]+(>|$)|[~`!<\>#$^{[}\]:;?+=_\|]|eval|windows/gi, '');
        }
        setformData((f) => ({ ...f, [name]: sanitizedValue }));
        console.log(formData);
    };
    useEffect(() => {
        let mounted = true;
        list_Internship().then((res) => {
            if (mounted) {
                setData(res.data);
            }
        });

        return () => {
            mounted = false;
        };
    }, []);
    useEffect(() => {
        if (props.data) {
            setformData(props.data);
        }
    }, [props.data]);

    const validate = () => {
        const { id, title, description, status, end_date } = formData;

        if (!title || !title.trim()) {
            toast.error('Please enter a valid title.');
            return;
        }

        const isDescriptionEmpty = (desc) => {
            if (!desc) return true;

            const cleaned = desc
                .replace(/<p><\/p>/gi, '')
                .replace(/<p><br><\/p>/gi, '')
                .replace(/&nbsp;/gi, '')
                .trim();

            const div = document.createElement('div');
            div.innerHTML = cleaned;
            const text = (div.textContent || div.innerText || '').trim();

            return text.length === 0;
        };

        if (!end_date || !end_date.trim()) {
            toast.error('Please enter a valid date');
            return;
        }

        if (isDescriptionEmpty(description)) {
            toast.error('Please enter a valid description.');
            return;
        }

        if (!status || (status !== 'active' && status !== 'inactive')) {
            toast.error('Please select a valid status.');
            return;
        }

        const payload = {
            ...(props.edit && id ? { id } : {}), 
            title: title.trim(),
            description,
            status,
            end_date,
            organisation: 'KIED', 
        };

        console.log('Final JSON Payload:', payload);

        handleApply(payload);
    };

    return (
        <div>
            <Modal isOpen={open} toggle={handleClose} size="lg">
                <ModalHeader toggle={handleClose} className="d-flex justify-content-center">
                    {props?.edit ? 'Update Internship' : 'Add New Internship'}
                </ModalHeader>
                <ModalBody>
                    <Form inline onSubmit={(e) => e.preventDefault()}>
                        <FormGroup className="col-12 mb-2">
                            <Label className="col-4 d-flex justify-content-start" for="exampleSelect">
                                Title
                            </Label>
                            <Input
                                className="col-8"
                                id="title"
                                name="select"
                                type="text"
                                la
                                value={formData?.title}
                                onChange={(e) => handleChange('title', e.target.value)}></Input>
                        </FormGroup>

                        <FormGroup className="col-12 mb-2">
                            <Label className="col-4 d-flex justify-content-start" for="exampleSelect">
                                Date
                            </Label>
                            <Input
                                className="col-8"
                                id="end_date"
                                name="select"
                                type="date"
                                value={formData?.end_date}
                                onChange={(e) => handleChange('end_date', e.target.value)}></Input>
                        </FormGroup>
                        <FormGroup className="col-12 mb-2">
                            <Label className="col-4 d-flex justify-content-start mb-2" for="exampleSelect">
                                Description
                            </Label>
                            <div className='col-12'>
                            <RichTextEditor
                                onEditorContentChange={(b) => handleChange('description', b)}
                                initialContent={formData?.description ?? ''}
                            />
                            </div>
                        </FormGroup>
                        <FormGroup className="col-12 mb-2">
                            <Label className="col-4 d-flex justify-content-start" for="status">
                                Status
                            </Label>
                            <Input
                                className="col-8"
                                id="status"
                                type="select"
                                value={formData?.status || ''}
                                onChange={(e) => handleChange('status', e.target.value)}>
                                <option value="">Select Status</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </Input>
                        </FormGroup>

                        <FormGroup className="col-12 mb-2">
                            <Label className="col-4 d-flex justify-content-start" for="exampleSelect">
                                Organisation
                            </Label>
                            <Input
                                className="col-8"
                                id="organisation"
                                name="organisation"
                                type="text"
                                value="KIED"
                                readOnly // Makes the field non-editable
                                onChange={(e) => handleChange('organisation', 'KIED')} // Always sets to KIED if somehow changed
                            />
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter className="d-flex justify-content-end">
                    <Button
                        color="primary"
                        // onClick={() => handleApply({...formData,organisation: 'KIED' })}
                        onClick={validate}>
                        {props.edit ? 'Update' : 'Create'}
                    </Button>
                    <Button color="btn btn-light text-secondary" onClick={() => handleClose()}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default AddInternship;
